// Textos del módulo Personal (turnos). Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosPersonal = defineTextos({
  titulo: 'Personal',
  trabajadores: 'Trabajadores',
  turnosEstaSemana: 'Turnos esta semana',
  semanaAnterior: 'Semana anterior',
  semanaSiguiente: 'Semana siguiente',
  hoy: 'Hoy',
  turnosDeLaSemana: 'Turnos de la semana — sede',
  soloLectura: ' · solo lectura',
  errorCargando: 'Error cargando el módulo',
  reiniciasteApi: ' ¿Reiniciaste la API? Las rutas /api/turnos y la migración 024 se cargan al arrancar.',
  cargandoTurnos: 'Cargando turnos…',
  trabajador: 'Trabajador',
  agregarTurno: 'Agregar turno',
  sinTrabajadores: 'No hay trabajadores activos. Creálos en el módulo',
  moduloUsuarios: 'Usuarios',
  apareceranAca: 'y aparecerán acá.',
  diaLun: 'Lun', diaMar: 'Mar', diaMie: 'Mié', diaJue: 'Jue', diaVie: 'Vie', diaSab: 'Sáb', diaDom: 'Dom',
  horaFinMayor: 'La hora fin debe ser mayor a la de inicio.',
  noSeGuardo: 'No se pudo guardar el turno.',
  noSeElimino: 'No se pudo eliminar.',
  editarTurno: 'Editar turno',
  nuevoTurno: 'Nuevo turno',
  cerrar: 'Cerrar',
  horaInicio: 'Hora inicio *',
  horaFin: 'Hora fin *',
  puestoOpcional: 'Puesto (opcional)',
  puestoPlaceholder: 'Salón, Caja, Cocina, Barra…',
  notasOpcional: 'Notas (opcional)',
  eliminar: 'Eliminar',
  guardando: 'Guardando…',
  guardarCambios: 'Guardar cambios',
  crearTurno: 'Crear turno',
}, {
  titulo: 'Staff',
  trabajadores: 'Workers',
  turnosEstaSemana: 'Shifts this week',
  semanaAnterior: 'Previous week',
  semanaSiguiente: 'Next week',
  hoy: 'Today',
  turnosDeLaSemana: 'Shifts for the week, branch',
  soloLectura: ' · read only',
  errorCargando: 'Error loading the module',
  reiniciasteApi: ' Did you restart the API? The /api/turnos routes and migration 024 load at startup.',
  cargandoTurnos: 'Loading shifts…',
  trabajador: 'Worker',
  agregarTurno: 'Add shift',
  sinTrabajadores: 'There are no active workers. Create them in the',
  moduloUsuarios: 'Users',
  apareceranAca: 'module and they will show up here.',
  diaLun: 'Mon', diaMar: 'Tue', diaMie: 'Wed', diaJue: 'Thu', diaVie: 'Fri', diaSab: 'Sat', diaDom: 'Sun',
  horaFinMayor: 'The end time must be later than the start time.',
  noSeGuardo: 'Could not save the shift.',
  noSeElimino: 'Could not delete it.',
  editarTurno: 'Edit shift',
  nuevoTurno: 'New shift',
  cerrar: 'Close',
  horaInicio: 'Start time *',
  horaFin: 'End time *',
  puestoOpcional: 'Position (optional)',
  puestoPlaceholder: 'Floor, Register, Kitchen, Bar…',
  notasOpcional: 'Notes (optional)',
  eliminar: 'Delete',
  guardando: 'Saving…',
  guardarCambios: 'Save changes',
  crearTurno: 'Create shift',
});
